<template>
  <section class="py-5 full-width">
    <div class="container full-width">
      <div class="full-width d-flex align-items-start full-width">
        <AccountOpes />
        <div class="flex-full aiz-user-panel full-width">
          <slot></slot>
        </div>
      </div>
    </div>
  </section>
</template>
<script>
import AccountOpes from "@/components/AccountOpes.vue";

export default {
  components: { AccountOpes }
};
</script>
